export enum ContractPermission {
    None = 0,
    Self = 1,
    Others = 2,
    SelfAndOthers = 3,
    NotAssign = 4
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/contractPermission.ts